<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="here px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">申込者情報の登録</h3>
    <p>以下の必要な項目をご入力のうえ、確認画面へ進むを押してください。</p>
    <div class="form-content">
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>
              氏名
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="name1"
                ref="name1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)真奈"
                style="ime-mode: active"
              />
              <input
                v-model="name2"
                ref="name2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)美須子"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              氏名
              <span class="fs-08">（フリガナ）</span>
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="nameKana1"
                ref="nameKana1"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)マナ"
                style="ime-mode: active"
              />
              <input
                v-model="nameKana2"
                ref="nameKana2"
                maxlength="20"
                type="text"
                class="input-name mr-3"
                placeholder="(例)ビスコ"
                style="ime-mode: active"
              /><br />
              <p class="fs-09">カタカナで入力してください。</p>
            </dd>
            <dt>
              性別
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="sex"
                ref="sex"
                value="1"
                id="rdoSexW"
                name="sex"
                type="radio"
                class="radio-01"
              />
              <label for="rdoSexW">女性</label>
              <input
                v-model="sex"
                ref="sex"
                value="2"
                id="rdoSexM"
                name="sex"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoSexM">男性</label>
            </dd>
            <dt>
              配偶者
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="spouse"
                ref="spouse"
                value="1"
                id="rdoSpouseY"
                name="Spouse"
                type="radio"
                class="radio-01"
              />
              <label for="rdoSpouseY">有り</label>
              <input
                v-model="spouse"
                ref="spouse"
                value="2"
                id="rdoSpouseN"
                name="Spouse"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoSpouseN">無し</label>
            </dd>
            <dt>
              生年月日
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <select
                v-model="birthYear"
                class="px-3"
                ref="birthYear"
                id="selBirthYear"
              >
                <option value="">－</option>
                <option v-for="item in yearList" :key="item" :value="item">
                  {{ item }}
                </option></select
              >年
              <select
                v-model="birthMonth"
                ref="birthMonth"
                id="selBirthMonth"
                class="ml-2e px-3"
              >
                <option value="">－</option>
                <option v-for="n of 12" :key="n" :value="n">
                  {{ n }}
                </option></select
              >月
              <select
                v-model="birthDay"
                ref="birthDay"
                id="selBirthDay"
                class="ml-2e px-3"
              >
                <option value="">－</option>
                <option v-for="n of dayCount" :key="n" :value="n">
                  {{ n }}
                </option></select
              >日
            </dd>
            <dt>
              郵便番号
              <span class="rqr">必須</span>
            </dt>
            <dd>
              〒
              <input
                v-model="zipCode"
                ref="zipCode"
                id="txtZipCode"
                maxlength="7"
                type="text"
                inputmode="numeric"
                class="input-name"
                placeholder="(例)2790032"
                style="ime-mode: disabled"
              />
              <button
                v-on:click="zipSearch"
                id="spnZipSearch"
                class="p-serch ml-3 mt-2"
              >
                住所検索
              </button>
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>
              住所
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="part1OfAddress"
                ref="part1OfAddress"
                id="txtAddress1"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)千葉県浦安市千鳥15-9"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              住所
              <span class="fs-08">（フリガナ）</span>
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="addressKana"
                ref="addressKana"
                id="txtAddressKana"
                maxlength="300"
                type="text"
                class="w-100"
                placeholder="(例)チバケンウラヤスシチドリ15バンチ8"
                style="ime-mode: active"
              /><br />
              <p class="fs-09">カタカナで入力してください。</p>
            </dd>
            <dt>
              住所
              <span class="fs-08">（建物名）</span>
            </dt>
            <dd>
              <input
                v-model="part2OfAddress"
                ref="part2OfAddress"
                id="txtAddress2"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)マナビスマンション101"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              住所
              <span class="fs-08">（その他）</span>
            </dt>
            <dd>
              <input
                v-model="part3OfAddress"
                ref="part3OfAddress"
                id="txtAddress3"
                maxlength="100"
                type="text"
                class="w-100"
                placeholder="(例)浦安舞子方"
                style="ime-mode: active"
              />
            </dd>
            <dt>
              配送時連絡先
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="useTelKind"
                ref="useTelKind"
                value="携帯"
                id="rdoUseM"
                name="use"
                type="radio"
                class="radio-01"
              />
              <label for="rdoUseM">携帯電話番号</label>
              <input
                v-model="useTelKind"
                value="固定"
                id="rdoUseK"
                name="use"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoUseK">自宅電話番号</label>
            </dd>
            <dt v-show="useTelKind == '携帯'">
              携帯電話番号
              <span id="spnTelM" class="rqr" style="">必須</span>
            </dt>
            <dd v-show="useTelKind == '携帯'">
              <input
                v-model="telM"
                ref="telM"
                id="txtTelM"
                maxlength="11"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)99999999999"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt v-show="useTelKind == '固定'">
              自宅電話番号
              <span id="spnTelK" class="rqr">必須</span>
            </dt>
            <dd v-show="useTelKind == '固定'">
              <input
                v-model="telK"
                ref="telK"
                id="txtTelK"
                maxlength="10"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)9999999999"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>FAX番号</dt>
            <dd>
              <input
                v-model="telF"
                ref="telF"
                id="txtTelF"
                maxlength="10"
                type="text"
                inputmode="numeric"
                class="input-w30"
                placeholder="(例)0888888888"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">ハイフン(-)は除いてください。</p>
            </dd>
            <dt>
              パスワード
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="passWord"
                ref="passWord"
                id="txtPasswd"
                type="password"
                maxlength="12"
                class="input-w30"
                style="ime-mode: disabled"
              />
              <br />
              <p class="fs-09">
                半角英数字の組合せ8～12文字以内で、ご自由にお決めください。<br />
                ここで入力したパスワードは、会員サイトへのログイン用になります。
              </p>
            </dd>
            <dt>
              当社からの広告等のメール・SMS・FAX送信
              <span class="rqr">必須</span>
            </dt>
            <dd>
              <input
                v-model="wantMail"
                ref="wantMail"
                value="1"
                id="rdoWantMailY"
                name="mss"
                type="radio"
                class="radio-01"
              />
              <label for="rdoWantMailY">承諾する</label>
              <input
                v-model="wantMail"
                ref="wantMail"
                value="0"
                id="rdoWantMailN"
                name="mss"
                type="radio"
                class="radio-01 ml-2e"
              />
              <label for="rdoWantMailN">承諾しない</label>
            </dd>
          </dl>
          <div class="box-p-20 text-center">
            <router-link
              :to="{ path: '/mock/influencer/registration/confirm' }"
              class="btn d-inline-block"
              >確認画面へ進む</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>

<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>